import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-switch',
  styles: [`
.form-check-input {
  width: 2.5rem !important;
  height: 1.3rem !important;
}
  `],
  template: `
  <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        [id]="id"
        [formControl]="control"
        [formlyAttributes]="field"
      />
      <label class="form-check-label d-block w-100 ms-2" [for]="id">
        {{ to.label }}
      </label>
      <small
        *ngIf="to.description"
        class="form-text text-muted d-block w-100 m-0"
      >
        {{ to.description }}
      </small>
    </div>
  `,
  standalone: false
})
export class SwitchTypeComponent extends FieldType {

  get control() {
    return this.formControl as any;
  }

}